/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Kpis, MainRates, MonthlyStatistic, Rate, TopRatesFilter } from '../states/dashboard-state';
import { StatisticsFilter } from '../../../../../redux/models/statistics/statistics-filter';
import { ICompanyNameAndOffice } from '../../models/dashboard.model';

export enum ActionTypes {
  SetCurrentChart = '[AVCDASHBOARD] set chart data for current year',
  SetCurrentChartSuccess = '[AVCDASHBOARD] set chart data for current year - success',
  SetCurrentChartError = '[AVCDASHBOARD] set chart data for current year - error',
  SetOneYearAgoChart = '[AVCDASHBOARD] set chart data for one year ago',
  SetOneYearAgoChartSuccess = '[AVCDASHBOARD] set chart data for one year ago - success',
  SetOneYearAgoChartError = '[AVCDASHBOARD] set chart data for one year ago - error',
  SetTwoYearsAgoChart = '[AVCDASHBOARD] set chart data for two years ago',
  SetTwoYearsAgoChartSuccess = '[AVCDASHBOARD] set chart data for two years ago - success',
  SetTwoYearsAgoChartError = '[AVCDASHBOARD] set chart data for two years ago - error',
  SetTopRates = '[AVCDASHBOARD] set top rates data',
  SetTopRatesSuccess = '[AVCDASHBOARD] set top rates - success',
  SetTopRatesError = '[AVCDASHBOARD] set top rates - error',
  SetSubTopRatesCity = '[AVCDASHBOARD] set sub top rates for city data',
  SetSubTopRatesCitySuccess = '[AVCDASHBOARD] set sub top rates for city data - success',
  SetSubTopRatesCityError = '[AVCDASHBOARD] set sub top rates for city data - error',
  SetSubTopRatesHotel = '[AVCDASHBOARD] set sub top rates for hotel data',
  SetSubTopRatesHotelSuccess = '[AVCDASHBOARD] set sub top rates for hotel data - success',
  SetSubTopRatesHotelError = '[AVCDASHBOARD] set sub top rates for hotel data - error',
  StoreStatisticsFilters = '[AVCDASHBOARD] store selected statistics filters',
  RequestBookingOffices = '[AVCDASHBOARD] request all booking office ids',
  RequestBookingOfficesSuccess = '[AVCDASHBOARD] all booking office ids received successfully',
  RequestBookingOfficesError = '[AVCDASHBOARD] request all booking office ids - error',
  ClearAllStatistics = '[AVCDASHBOARD] clear all statistics',
}

export class SetCurrentChart implements Action {
  readonly type = ActionTypes.SetCurrentChart;
  constructor(public statisticFilter: StatisticsFilter) {}
}

export class SetCurrentChartSuccess implements Action {
  readonly type = ActionTypes.SetCurrentChartSuccess;
  constructor(public statistics: MonthlyStatistic[], public kpis: Kpis) {}
}

export class SetOneYearAgoChart implements Action {
  readonly type = ActionTypes.SetOneYearAgoChart;
  constructor(public statisticFilter: StatisticsFilter) {}
}

export class SetOneYearAgoChartSuccess implements Action {
  readonly type = ActionTypes.SetOneYearAgoChartSuccess;
  constructor(public statistics: MonthlyStatistic[], public kpis: Kpis) {}
}

export class SetTwoYearsAgoChart implements Action {
  readonly type = ActionTypes.SetTwoYearsAgoChart;
  constructor(public statisticFilter: StatisticsFilter) {}
}

export class SetTwoYearsAgoChartSuccess implements Action {
  readonly type = ActionTypes.SetTwoYearsAgoChartSuccess;
  constructor(public statistics: MonthlyStatistic[]) {}
}

export class SetTopRates implements Action {
  readonly type = ActionTypes.SetTopRates;
  constructor(public statisticFilter: StatisticsFilter, public topRatesFilter: TopRatesFilter) {}
}

export class SetTopRatesSuccess implements Action {
  readonly type = ActionTypes.SetTopRatesSuccess;
  constructor(public rate: MainRates) {}
}

export class SetSubTopRatesCity implements Action {
  readonly type = ActionTypes.SetSubTopRatesCity;
  constructor(public statisticFilter: StatisticsFilter, public topRatesFilter: TopRatesFilter, public countryCode: string) {}
}

export class SetSubTopRatesCitySuccess implements Action {
  readonly type = ActionTypes.SetSubTopRatesCitySuccess;
  constructor(public rates: Rate[]) {}
}

export class SetSubTopRatesHotel implements Action {
  readonly type = ActionTypes.SetSubTopRatesHotel;
  constructor(public statisticFilter: StatisticsFilter, public topRatesFilter: TopRatesFilter, public cityCode: string) {}
}

export class SetSubTopRatesHotelSuccess implements Action {
  readonly type = ActionTypes.SetSubTopRatesHotelSuccess;
  constructor(public rates: Rate[]) {}
}

export class StoreStatisticsFilters implements Action {
  readonly type = ActionTypes.StoreStatisticsFilters;
  constructor(public filters: StatisticsFilter) {}
}

export class RequestBookingOffices implements Action {
  readonly type = ActionTypes.RequestBookingOffices;
  constructor() {}
}

export class RequestBookingOfficesSuccess implements Action {
  readonly type = ActionTypes.RequestBookingOfficesSuccess;
  constructor(public offices: ICompanyNameAndOffice[] | string[]) {}
}

export class ClearAllStatistics implements Action {
  readonly type = ActionTypes.ClearAllStatistics;
  constructor() {}
}

export class SetCurrentChartError implements Action {
  readonly type = ActionTypes.SetCurrentChartError;
  constructor(public payload: any) {}
}

export class SetOneYearAgoChartError implements Action {
  readonly type = ActionTypes.SetOneYearAgoChartError;
  constructor(public payload: any) {}
}

export class SetTwoYearsAgoChartError implements Action {
  readonly type = ActionTypes.SetTwoYearsAgoChartError;
  constructor(public payload: any) {}
}

export class SetTopRatesError implements Action {
  readonly type = ActionTypes.SetTopRatesError;
  constructor(public payload: any) {}
}

export class SetSubTopRatesCityError implements Action {
  readonly type = ActionTypes.SetSubTopRatesCityError;
  constructor(public payload: any) {}
}

export class SetSubTopRatesHotelError implements Action {
  readonly type = ActionTypes.SetSubTopRatesHotelError;
  constructor(public payload: any) {}
}


export class RequestBookingOfficesError implements Action {
  readonly type = ActionTypes.RequestBookingOfficesError;
  constructor(public payload: any) {}
}

export type Actions =
  | SetCurrentChart
  | SetCurrentChartSuccess
  | SetOneYearAgoChart
  | SetOneYearAgoChartSuccess
  | SetTwoYearsAgoChart
  | SetTwoYearsAgoChartSuccess
  | SetTopRates
  | SetTopRatesSuccess
  | SetSubTopRatesCity
  | SetSubTopRatesCitySuccess
  | SetSubTopRatesHotel
  | SetSubTopRatesHotelSuccess
  | StoreStatisticsFilters
  | RequestBookingOffices
  | RequestBookingOfficesSuccess
  | ClearAllStatistics
  | SetCurrentChartError
  | SetOneYearAgoChartError
  | SetTwoYearsAgoChartError
  | SetTopRatesError
  | SetSubTopRatesCityError
  | SetSubTopRatesHotelError
  | RequestBookingOfficesError;
